<div class="cancel-transport-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.cancel-transport-dialog.title"></sc-dictionary-label>
    </h2>

    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.driver"
      [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content cancel-transport-content">

      <mat-radio-group [(ngModel)]="selectedViewMode" class="view-modes">
        <mat-radio-button class="margin-right-15" value="{{viewModeRepeatProcessing}}">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.cancel-transport-dialog.mode.repeat-processing"></sc-dictionary-label>
        </mat-radio-button>
        <mat-radio-button value="{{viewModeForwardTransport}}">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.cancel-transport-dialog.mode.forward-transport"></sc-dictionary-label>
        </mat-radio-button>
      </mat-radio-group>

      <div class="repeating" [hidden]="selectedViewMode !== viewModeRepeatProcessing" [formGroup]="formGroup">
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-string-field formControlName="reason" labelDictionaryKey="tmc-yard.ui.control.sac-client.cancel-transport-dialog.cancellation-reason"></sc-string-field>
        <sc-sub-title>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.cancel-transport-dialog.destination-station"></sc-dictionary-label>
        </sc-sub-title>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-radio-group class="station-selection" aria-label="Select an option" [(ngModel)]="selectedStationForRepeat"
          [ngModelOptions]="{standalone: true}">
          @for (station of data.stationForRepeatProcessing; track station) {
            <mat-radio-button class="option" [value]="station">
              {{station.title}}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>

      <div class="forwarding" [hidden]="selectedViewMode !== viewModeForwardTransport">
        <div class="inline-flex">
          <app-dictionary-key-select (selectionChanged)="forwardingOptionsChanged($event)" class="forwarding-cause"
            [required]="configurationService.isPropertyTrue('ui-component.station-assignment-client.cancel-transport-dialog.forwarding-cause.required', true)"
            label="{{'forwarding cause' | translate: ['tmc-yard.ui.control.sac-client.cancel-transport-dialog.forwarding-cause-selection.title', translationService.language, translationService.revision]}}"
            [rootKey]="'tmc-yard.service.lookup.forwarding-cause.options'">
          </app-dictionary-key-select>
        </div>
        <app-station-selection [stationGroups]="this.data.stationForForwarding" [includeStations]="true"
          [includeWaitingareas]="false" [requiredSelectionLevels]="requiredSelectionLevels"
          (selectionChanged)="onForwardingStationSelectionChanged($event)">
        </app-station-selection>
      </div>
    </div>

    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>
    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" (click)="cancelDialog()"
      [disabled]="isCancelDisabled()" dictionaryKey="shared.selection-dialog.action.cancel"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button primary (click)="confirm()" class="confirm-button"
      [disabled]="isConfirmDisabled()" dictionaryKey="tmc-yard.ui.control.sac-client.cancel-transport-dialog.action.confirm"></sc-confirm-button>
    </sc-actionbar>
  </div>
</div>
